import { createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance, { clearToken, setToken } from '../../utils/axios';
import { fetchStructure } from '../location/operations';
import { UserModel, UserProfile } from './model';
import { toast } from 'react-toastify';
import { AxiosError } from 'axios';
import Cookies from 'js-cookie';

export const setUser = createAsyncThunk('user/setUser', async (userModel: UserModel, thunkAPI) => {
  setToken(userModel.token);
  thunkAPI.dispatch(fetchStructure());

  return userModel;
});

export const cleanUser = createAsyncThunk('user/cleanUser', async () => {
  Cookies.removeItem('user');
  Cookies.removeItem('structure');
  clearToken();
});

export const passwordReminder = async (email: string) => {
  try {
    await axiosInstance.put('/v1/user/password-reset?email=' + email);
    toast.success('Link do resetu hasła został wysłany na podany adres email.', { position: 'bottom-left' });
  } catch (e) {
    console.log(e);
    throw e;
  }
};

export const passwordReset = async (password: string, token: string) => {
  try {
    const body = { newPassword: password };
    await axiosInstance.put('/v1/user/password-reset/update?token=' + token, JSON.stringify(body));
    toast.success('Nowe hasło zostało poprawnie zapisane.', { position: 'bottom-left' });
  } catch (e) {
    const typedError = e as AxiosError;
    console.log(typedError);
    toast.error(typedError?.message);
    throw e;
  }
};

export const checkToken = async (token: string): Promise<boolean> => {
  try {
    await axiosInstance.get('/v1/user/password-reset/details?token=' + token);
    return true;
  } catch (e) {
    console.log(e);

    return false;
  }
};

export const getProfile = createAsyncThunk('user/profile', async () => {
  try {
    const result = await axiosInstance.get<UserProfile>('/v1/profile');
    console.log('Profile', result);
    return result.data;
  } catch (e) {
    console.log(e);
  }
});